// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Btn from "../../../html/Btn.js";
import * as Buhta_cabinet__CalendarDatePickerInput from "../../../molecules/CalendarDatePickerInput.js";
import * as Buhta_cabinet__Date from "../../../../util/Date.js";
import * as Buhta_cabinet__Dropdowns from "../../../molecules/Dropdowns.js";
import * as Buhta_cabinet__Field from "../../../html/Field.js";
import * as Buhta_cabinet__RadioButton from "../../../html/RadioButton.js";
import * as Buhta_cabinet__TaxControl from "../../../../grpc/TaxControl.js";
import * as Buhta_cabinet__ToastSender from "../../../../util/ToastSender.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../../../packages/core/lib/Toast.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../../packages/util/lib/DateTime.js";
import * as $$Promise from "../../../../../../../vendored/promise/promise.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(org) {
  return function (onSuccess) {
    const match = Buhta_core__Toast.ToastsContext.useToasts(undefined);
    const dispatchToasts = match[1];
    const match$1 = React.useState(function () {
          return "";
        });
    const setRegistrationDate = match$1[1];
    const registrationDate = match$1[0];
    const match$2 = React.useState(function () {
          return /* TAX_MODE_UNSPECIFIED */0;
        });
    const setTaxMode = match$2[1];
    const taxMode = match$2[0];
    const match$3 = React.useState(function () {
          return "";
        });
    const setTaxModeError = match$3[1];
    const match$4 = React.useState(function () {
          return "";
        });
    const setKogd = match$4[1];
    const kogd = match$4[0];
    const match$5 = React.useState(function () {
          return "";
        });
    const setKogdLiving = match$5[1];
    const kogdLiving = match$5[0];
    const match$6 = React.useState(function () {
          return "option1";
        });
    const setNdsOption = match$6[1];
    const ndsOption = match$6[0];
    const match$7 = React.useState(function () {
          return "";
        });
    const setNdsSeries = match$7[1];
    const match$8 = React.useState(function () {
          return "";
        });
    const setNdsNumber = match$8[1];
    const match$9 = React.useState(function () {
          return "";
        });
    const setNdsRate = match$9[1];
    const match$10 = React.useState(function () {
          return "";
        });
    const setNdsIssueDate = match$10[1];
    const match$11 = Buhta_core__Tenant.useTenant(undefined);
    const tenant = match$11[0];
    const func = Buhta_cabinet__TaxControl.TaxInformationService.view;
    const match$12 = Buhta_core__GrpcState.useModel((function (param) {
            return Curry._2(func, param, /* [] */0);
          }), undefined);
    const dispatch = match$12[1];
    const settings = match$12[0];
    React.useEffect((function () {
            Curry._2(dispatch, undefined, undefined);
          }), []);
    React.useEffect((function () {
            if (typeof settings !== "string" && settings.NAME === "Data") {
              const settings$1 = settings.VAL;
              Curry._1(setTaxMode, (function (param) {
                      return settings$1.mode;
                    }));
              Curry._1(setKogd, (function (param) {
                      return settings$1.kogd;
                    }));
              Curry._1(setKogdLiving, (function (param) {
                      return Belt__Belt_Option.getWithDefault(settings$1.kogd_living, "");
                    }));
              Belt__Belt_Option.forEach(settings$1.register_date, (function (date) {
                      Curry._1(setRegistrationDate, (function (param) {
                              return Buhta_cabinet__Date.toString(date);
                            }));
                    }));
            }
            
          }), [settings]);
    const saveSettings = function (ev) {
      ev.preventDefault();
      if (!taxMode) {
        return Curry._1(setTaxModeError, (function (param) {
                      return "Поле обязательно";
                    }));
      }
      const settingsForm_register_date = registrationDate === "" ? undefined : Buhta_cabinet__Date.fromString(registrationDate);
      const settingsForm_kogd_living = kogdLiving === "" ? undefined : kogdLiving;
      const settingsForm = {
        id: "",
        mode: taxMode,
        register_date: settingsForm_register_date,
        kogd: kogd,
        kogd_living: settingsForm_kogd_living,
        vat: undefined,
        create_time: undefined,
        update_time: undefined
      };
      const __x = Buhta_cabinet__TaxControl.TaxInformationService.update(tenant, settingsForm);
      $$Promise.get(__x, (function (result) {
              if (result.TAG !== /* Ok */0) {
                return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при сохранении");
              }
              Curry._1(dispatchToasts, {
                    TAG: /* Add */0,
                    _0: {
                      id: Buhta_core__Toast.generateId(undefined),
                      text: "Настройки сохранены",
                      kind: "success",
                      onClick: (function (param) {
                          
                        })
                    }
                  });
              Curry._1(onSuccess, undefined);
            }));
    };
    return JsxRuntime.jsxs("form", {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                        value: registrationDate,
                                        onPicked: (function (date) {
                                            Curry._1(setRegistrationDate, (function (param) {
                                                    return DateTime.toDateFormat(date);
                                                  }));
                                          }),
                                        align: "BottomLeft",
                                        label: "Дата регистрации предприятия",
                                        tillCurrentDate: true
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__Dropdowns.TaxModeSelect.make, {
                                        taxMode: taxMode,
                                        onTaxModeSelect: (function (value) {
                                            Curry._1(setTaxMode, (function (state) {
                                                    return value;
                                                  }));
                                            Curry._1(setTaxModeError, (function (param) {
                                                    return "";
                                                  }));
                                          }),
                                        error: match$3[0]
                                      })
                                ],
                                className: "px-6 py-10 md:p-10"
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                        className: "text-default-gray",
                                        children: "Код органа гос. доходов"
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__Dropdowns.KogdSelect.make, {
                                        kogd: kogd,
                                        onKogdSelect: (function (value) {
                                            Curry._1(setKogd, (function (param) {
                                                    return value;
                                                  }));
                                          }),
                                        label: "По месту нахождения"
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__Dropdowns.KogdSelect.make, {
                                        kogd: kogdLiving,
                                        onKogdSelect: (function (value) {
                                            Curry._1(setKogdLiving, (function (param) {
                                                    return value;
                                                  }));
                                          }),
                                        label: "По месту жительства"
                                      })
                                ],
                                className: "rounded-md px-6 md:px-10 pb-10 md:-mt-2"
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                        className: "text-default-gray",
                                        children: "НДС"
                                      }),
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                                className: "mt-4",
                                                checked: ndsOption === "option1",
                                                onChange: (function (param) {
                                                    Curry._1(setNdsOption, (function (param) {
                                                            return "option1";
                                                          }));
                                                  }),
                                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                      className: "ml-1",
                                                      children: "Без НДС"
                                                    })
                                              }),
                                          JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                                className: "mt-4",
                                                checked: ndsOption === "option2",
                                                onChange: (function (param) {
                                                    Curry._1(setNdsOption, (function (param) {
                                                            return "option2";
                                                          }));
                                                  }),
                                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                      className: "ml-1",
                                                      children: "С НДС"
                                                    })
                                              })
                                        ],
                                        className: "flex gap-6"
                                      }),
                                  ndsOption === "option2" ? JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                          label: "Серия",
                                                          type_: "text",
                                                          name: "ndsSeries",
                                                          size: "m",
                                                          onChange: (function (value) {
                                                              Curry._1(setNdsSeries, (function (param) {
                                                                      return value;
                                                                    }));
                                                            }),
                                                          value: match$7[0]
                                                        }),
                                                    JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                          label: "Номер",
                                                          type_: "text",
                                                          name: "ndsNumber",
                                                          size: "m",
                                                          onChange: (function (value) {
                                                              Curry._1(setNdsNumber, (function (param) {
                                                                      return value;
                                                                    }));
                                                            }),
                                                          value: match$8[0]
                                                        })
                                                  ],
                                                  className: "grid grid-cols-2 items-center gap-4 mt-6"
                                                }),
                                            JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                  value: match$10[0],
                                                  onPicked: (function (date) {
                                                      Curry._1(setNdsIssueDate, (function (param) {
                                                              return DateTime.toDateFormat(date);
                                                            }));
                                                    }),
                                                  align: "BottomRight",
                                                  label: "Дата выдачи"
                                                }),
                                            JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                  label: "Ставка",
                                                  type_: "text",
                                                  name: "ndsRate",
                                                  size: "m",
                                                  onChange: (function (value) {
                                                      Curry._1(setNdsRate, (function (param) {
                                                              return value;
                                                            }));
                                                    }),
                                                  value: match$9[0]
                                                })
                                          ],
                                          className: "flex flex-col gap-4"
                                        }) : null
                                ],
                                className: "rounded-md px-6 md:px-10 pb-10 md:-mt-2"
                              })
                        ],
                        className: "bg-white min-w-[343px] md:w-[562px] rounded-md shadow-kkm"
                      }),
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                              title: "Продолжить",
                              className: "px-6 py-3 w-full md:w-max",
                              type_: "submit"
                            }),
                        className: "w-full md:w-[562px] flex justify-end mt-6"
                      })
                ],
                onSubmit: saveSettings
              });
  };
}

function TaxPaymentsSettingsOrg(Props) {
  return make(Props.org)(Props.onSuccess);
}

const make$1 = TaxPaymentsSettingsOrg;

export {
  make$1 as make,
}
/* Buhta_cabinet__Btn Not a pure module */
